import React from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import ApexRadial from "./ApexRadial";

const MonthlyEarning = ({ dashboardData }) => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Statistics</CardTitle>
        <Row className="mb-5">
          <Col sm="12">
              <Row>
                <Col xs="6">
                  {String(dashboardData.label4Value).length > 15 ? < h6 className="font-size-15">{dashboardData.label4Value}</h6> : < h5 className="font-size-15">{dashboardData.label4Value}</h5>}
                  <p className="text-muted mb-0">{dashboardData.label4}</p>
                </Col>
                <Col xs="6">
                  {String(dashboardData.label5Value).length > 15 ? <h6 className="font-size-15">{dashboardData.label5Value}</h6> : <h5 className="font-size-15">{dashboardData.label5Value}</h5>}
                  <p className="text-muted mb-0">{dashboardData.label5}</p>
                </Col>
              </Row>
          </Col>
        </Row>
        <Row>
          <Col sm="6">
            <p className="text-muted">{dashboardData.label6}</p>
            {String(dashboardData.label6Value).length > 14 ? <h6>{dashboardData.label6Value}</h6> : String(dashboardData.label6Value).length > 10 ? <h5>{dashboardData.label6Value}</h5> : String(dashboardData.label6Value).length > 10 ? <h4>{dashboardData.label6Value}</h4> : <h3>{dashboardData.label6Value}</h3>}
            <p className="text-muted">
              {parseFloat(dashboardData.label7Value) > 0 ? (
                <span className="text-success me-2">
                  {parseFloat(dashboardData.label7Value).toFixed(2)}%{" "}
                  <i className="mdi mdi-arrow-up"></i>
                </span>
              ) : (
                <span className="text-danger me-2">
                  {parseFloat(dashboardData.label7Value).toFixed(2)}%{" "}
                  <i className="mdi mdi-arrow-down"></i>
                </span>
              )}
              {dashboardData.label7}
            </p>
          </Col>
          <Col sm="6">
            <div className="mt-4 mt-sm-0">
              <ApexRadial archivement={dashboardData} />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default MonthlyEarning;
